import { ComponentNavPageRedirect } from 'Component'

const PageApiRedirect = () => <ComponentNavPageRedirect navKey={'ws'}/>

export default PageApiRedirect